/**
 * @generated SignedSource<<dfc6f8bf6ae4132bbc2fc6a7d4da5f89>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type pipelineHeadBuildTypeFragment$data = {
  readonly id: Branded<string, 'BuildTypeId'> | null | undefined;
  readonly " $fragmentType": "pipelineHeadBuildTypeFragment";
};
export type pipelineHeadBuildTypeFragment$key = {
  readonly " $data"?: pipelineHeadBuildTypeFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"pipelineHeadBuildTypeFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "pipelineHeadBuildTypeFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "BuildTypeRest",
  "abstractKey": null
};

(node as any).hash = "5652788eba72df31d68535b12c96b080";

export default node;
